<div nz-col class="users-content" nzSpan="24">
  <nz-spin nzTip="Loading..." [nzSize]="'large'" [nzSpinning]="isLoading">
    <div class="content">
      <div class="table-content">
        <nz-table
          nzSize="small"
          [nzData]="rowsToDisplay"
          nzTableLayout="fixed"
          nzShowPagination
          nzShowSizeChanger
          [nzLoading]="isLoading"
          [nzFrontPagination]="true"
          [nzTotal]="totalCount!"
          [nzOuterBordered]="true"
          [nzPageSizeOptions]="supportedPageSizes"
          [nzNoResult]="noResultTemplate"
          [nzHideOnSinglePage]="false"
          [nzVirtualItemSize]="11"
          [nzScroll]="{ y: 'calc(100vh - 250px)' }"
          #borderedTable
          nzBordered
        >
          <thead>
            <tr>
              <th
                *ngFor="let cell of headers; index as i"
                nz-resizable
                [nzSortOrder]="cell.sortOrder"
                [nzSortFn]="cell.sortFn!"
                [nzFilterFn]="cell.filterFn || null"
                [nzSortDirections]="cell.sortDirections"
                [nzFilterMultiple]="cell.filterMultiple || false"
                [nzFilters]="cell.listOfFilter"
                [nzWidth]="cell.width ?? '5rem'"
                class="nfl-form-label"
                [nzCustomFilter]="i === 0 || i === 1"
                appResizableColumn
              >
                {{ cell.name }}
                <nz-filter-trigger
                  *ngIf="i === 0"
                  [(nzVisible)]="nameVisible"
                  [nzActive]="searchNameValue!.length > 0"
                  [nzDropdownMenu]="searchNameTpl"
                >
                  <span nz-icon nzType="search"></span>
                </nz-filter-trigger>
                <nz-filter-trigger
                  *ngIf="i === 1"
                  [(nzVisible)]="emailVisible"
                  [nzActive]="searchEmailValue!.length > 0"
                  [nzDropdownMenu]="searchEmailTpl"
                >
                  <span nz-icon nzType="search"></span>
                </nz-filter-trigger>
              </th>
              <th nzRight nzAlign="center" nzWidth="5rem">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of borderedTable.data">
              <td nzEllipsis>{{ data.name || '--' }}</td>
              <td nzEllipsis>{{ data.email }}</td>
              <td nzEllipsis *ngIf="!isNonNFLUser">{{ data.organization || '--' }}</td>
              <td nzEllipsis>{{ data.role || '--' }}</td>
              <td nzAlign="center">
                <nz-tag [nzColor]="getUserStatusColor(data.status)">
                  {{ data.status }}
                </nz-tag>
              </td>
              <td>{{ data.createdAt | dateTime }}</td>
              <td>{{ data.updatedAt | dateTime }}</td>
              <td>{{ data.lastActivity | dateTime }}</td>
              <td nzAlign="center" nzRight>
                <button nz-button nz-dropdown [nzDropdownMenu]="actionMenu" [disabled]="data.email === loggedInUser">
                  <span nz-icon nzType="more"></span>
                </button>
                <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                  <ul nz-menu *ngIf="data.email !== loggedInUser">
                    <li
                      nz-menu-item
                      *ngIf="authService.hasEntitlements(hasUserActionEntitlement)"
                      (click)="openEditUserModal(data)"
                    >
                      Edit
                    </li>
                    <li
                      nz-menu-item
                      *ngIf="data?.status === 'DISABLED' && authService.hasEntitlements(hasUserActionEntitlement)"
                      (click)="openUserActionsModal(data, userActions.ACTIVATE_USER)"
                    >
                      Activate
                    </li>
                    <li
                      nz-menu-item
                      *ngIf="data?.status === 'ENABLED' && authService.hasEntitlements(hasUserActionEntitlement)"
                      (click)="openUserActionsModal(data, userActions.DEACTIVATE_USER)"
                    >
                      Deactivate
                    </li>

                    <li
                      nz-menu-item
                      *ngIf="authService.hasEntitlements(hasUserActionEntitlement)"
                      (click)="openUserActionsModal(data, userActions.DELETE_USER)"
                    >
                      Delete
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </nz-spin>
</div>

<ng-template #noResultTemplate let-name>
  <div>
    <span nz-icon nzType="file-sync" nzTheme="outline"></span>
    <p>No records available</p>
  </div>
</ng-template>

<ng-template #blankCellTpl>
  <span nz-typography>--</span>
</ng-template>

<nz-dropdown-menu #searchNameTpl="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Search User Name" [(ngModel)]="searchNameValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="searchName()" class="search-button">Search</button>
      <button nz-button nzSize="small" (click)="resetName()">Reset</button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #searchEmailTpl="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Search User Email" [(ngModel)]="searchEmailValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="searchEmail()" class="search-button">Search</button>
      <button nz-button nzSize="small" (click)="resetEmail()">Reset</button>
    </div>
  </div>
</nz-dropdown-menu>
